import { CompanyAPI } from '@api/buser-http-client';

const getBankAccount = () => CompanyAPI.getBankAccount()
  .then((data) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { getBankAccount };
